import React from "react";
import { Navigation } from "../components/navigation";
import {Vine} from "../components/vine";
import { Header3 } from "../components/header";

const Vines = () => {
    return ( 
        <div>
        <Navigation></Navigation>
        <Header3></Header3>
        <Vine></Vine>
        
       </div>
    );
  };
  
  export default Vines;
  